// Cache knobs shared by the static `findMany` / `findFirst` query builders. Kept in one module so
// the two can't drift — they describe the same database and must agree.
//
// The static database is immutable read-only info data — it never changes within a session,
// so (unlike the actor queries) there is no change-version subscription. `staleTime: Infinity`
// makes exact-same reads in quick succession resolve from cache instead of re-hitting the source.
export const STATIC_QUERY_STALE_TIME = Number.POSITIVE_INFINITY;

/**
 * Keep only recently used static rows in JS. The per-query disk persister survives this GC,
 * so revisiting a glyph still works offline without retaining its decoded strokes all day.
 */
export const STATIC_QUERY_GC_TIME = 60 * 1000;

/**
 * Identifies immutable static reads, including entries in the pre-upgrade offline snapshot.
 * Their query options own persistence; the root provider restores only paused mutations.
 */
export const STATIC_QUERY_META = { persist: true } as const;
